import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";

const userAPI = createSlice({
    name: 'userAPI',
    initialState: {
        list: []
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserPage.fulfilled, (state, action) => {
            state.list = action.payload;
        })
    }
});

export const fetchUserPage = createAsyncThunk(
    'user/fetch/page',
    async ({page, filter, sort}) => {
        const response = await apiClient.get(`/api/v1/user`, null, page, filter, sort);
        return response.data.payload
    }
);

export default userAPI.reducer;
